import React, {useEffect, useState} from 'react';
import {useFormikContext} from 'formik';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import qs from 'qs';

import {getCollegeEventOptions} from 'shared/portfolio/actions/college-events';
import {Store} from 'src/types/store';

import Label from 'shared/components/label';
import FormikDatePicker from 'src/components/formik-date-picker';
import FormikTypeahead from 'src/components/formik-typeahead';
import FormikDropdown from 'src/components/formik-dropdown';

export const SHARED_COLLEGE_EVENTS = [
  'Campus Visit',
  'Summer Program',
  'College Fair',
  'College Reception',
];

export interface CollegeEventForm {
  _id?: string;
  name: string;
  collegeName: string;
  collegeId: string;
  month: number | '';
  year: number | '';
}

const CollegeEvent = () => {
  const formik = useFormikContext<CollegeEventForm>();
  const {search} = useLocation();
  const dispatch = useDispatch();
  const colleges = useSelector(
    (state: Store) => state.collegeSearchBar.collegeSearchBarData.colleges || {}
  );
  const collegeInteractionOptions = useSelector((state: Store) => state.collegeInteractionOptions);
  const [collegeNameOptions, setCollegeNameOptions] = useState<Record<string, string>[]>([]);
  const [eventOptions, setEventOptions] = useState([]);

  useEffect(() => {
    const {onlyAwardableEvents, event} = qs.parse(search.substr(1));

    dispatch(getCollegeEventOptions(onlyAwardableEvents === 'true'));

    if (event) {
      formik.setFieldValue('name', event);
    }
  }, []);

  useEffect(() => {
    setCollegeNameOptions(
      Object.keys(colleges).map((collegeName) => ({
        id: colleges[collegeName].id,
        value: collegeName,
        text: collegeName,
      }))
    );
  }, [colleges]);

  useEffect(() => {
    const collegeId = formik.values.collegeId;
    const events = (collegeId && collegeInteractionOptions[collegeId]) || SHARED_COLLEGE_EVENTS;

    setEventOptions(events.map((name) => ({_id: name, value: name, text: name})));
  }, [formik.values.collegeId, collegeInteractionOptions]);

  const handleSelect = (result) => {
    formik.setValues({
      ...formik.values,
      collegeName: result.text,
      collegeId: result.id,
    });
  };

  return (
    <>
      <Label required>
        College hosting event
        <FormikTypeahead
          id="college-event-typeahead"
          name="collegeName"
          required
          placeholder="College Name"
          onSelect={handleSelect}
          options={collegeNameOptions}
          cy="college-event-college-name"
        />
      </Label>
      <Label required>
        Event Type
        <FormikDropdown
          name="name"
          required
          options={eventOptions}
          cy="college-event-name"
          testid="college-event-name"
        />
      </Label>
      <FormikDatePicker monthName="month" yearName="year" required />
    </>
  );
};

export default CollegeEvent;
